fx.ns("filters.photofilters", class OldPictureFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);
    };

    
	filterFCN(add)
	{
        
        //<feFlood flood-color="#3a0339" flood-opacity="1" result="fill"></feFlood>
        //<feComposite in="SourceGraphic" in2="fill" operator="arithmetic" k1="0" k2="0.5" k3="0.5" k4="0"></feComposite>

        let flood = add.flood("#3a0339", 1)
                       .attr({'result' : 'fill'})
                       .attr({'x': 0,  'y' : 0, width : this.SVGElement.width(), height: this.SVGElement.height()});
        
        let composite = add.composite(add.$sourceAlpha, "arithmetic")
                           .attr({'k1': 0,  'k2' : 0.5, 'k3' : 0.5, "k4" : 0});

        this.elements.push(flood);
        this.elements.push(composite);

    }
    
    resize(width, height){
        for (let i = 0; i < this.elements.length; i++)
        if (this.elements[i].type == "feFlood")
            this.elements[i].size( width, height);
                            
    }
      


});
        